// @flow

import { createGlobalStyle } from 'styled-components';
import { theme } from '@tectonics/look-and-feel/uber-v2/theme/default-theme';
export const GlobalStyle = createGlobalStyle`
  html, body, #tectonics {
    font-size: ${theme.fontSize};
    font-family: ${theme.fontFamily.sansSerif};
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-rendering: optimizeLegibility;
  }

  * {
    font-size: inherit;
    font-family: inherit;
    box-sizing: border-box;
    margin: 0;
    padding: 0;
  }

  body {
    background: ${theme.colors.gray(89)};
  }
`;
